import { render, staticRenderFns } from "./ProductClassifyChange.vue?vue&type=template&id=2e4e977d&scoped=true&"
import script from "./ProductClassifyChange.vue?vue&type=script&lang=js&"
export * from "./ProductClassifyChange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4e977d",
  null
  
)

export default component.exports